import type { FC, ReactNode } from 'react'
import type { NavItem } from '@/components/generals/app-shell'

import {
    ArrowLeft,
    Building2,
    Flag,
    Gauge,
    History,
    Rss
} from 'lucide-react'

import { AppShell } from '@/components/generals/app-shell'

const ADMIN_NAV: Array<NavItem> = [
    { href: '/admin', label: 'Overview', icon: Gauge, exact: true },
    { href: '/admin/companies', label: 'Companies', icon: Building2 },
    { href: '/admin/sources', label: 'Job sources', icon: Rss },
    { href: '/admin/runs', label: 'Collection runs', icon: History },
    { href: '/admin/jobs', label: 'Job moderation', icon: Flag },
    { href: '/dashboard', label: 'Back to my workspace', icon: ArrowLeft, exact: true }
]

export const AdminShell: FC<{ children: ReactNode }> = ({ children }) => (
    <AppShell items={ADMIN_NAV} heading='Admin' showAdminLink={false}>
        {children}
    </AppShell>
)
